<template>
  <td class="is-hidden-mobile">
    <div class="field">
      <input
        class="is-checkradio"
        :id="inputId"
        type="checkbox"
        :checked="checked"
        @change="$emit('change')"
      >
      <label :for="inputId"></label>
    </div>
  </td>
</template>

<script>
export default {
  name: 'BulkSelectCell',

  props: {
    checked: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    inputId() {
      return 'bulk-select-' + this._uid
    }
  }
}
</script>
